import { ButtonSize, ButtonTheme, FontWeight, Typography, TypographyVariant, UseState } from '@elearning-platform/ui';
import React, { useMemo, useState } from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import { Container, Separator, StyledButton, StyledTextArea } from './openQuestion.styled';
import { OpenQuestionProps } from './openQuestion.types';

export const OpenQuestion: React.FC<OpenQuestionProps> = (props: OpenQuestionProps): JSX.Element => {
  const { data, onButtonClick }: OpenQuestionProps = props;
  const { t }: TransProps<never> = useTranslation();
  const [inputValue, setInputValue]: UseState<string> = useState<string>('');
  const [shouldValidate, setShouldValidate]: UseState<boolean> = useState<boolean>(false);
  const lengthLimit: number = 400;
  const isLengthWithinLimits: boolean = useMemo((): boolean => inputValue.length < lengthLimit && inputValue.length > 20, [inputValue]);

  return (
    <Container>
      <Typography fontWeight={FontWeight.Bold} variant={TypographyVariant.DisplayXS}>{data.title}</Typography>
      <Separator />
      <Typography variant={TypographyVariant.DisplaySM}>{data.question}</Typography>
      <StyledTextArea
        label={t('competence.app.interactions.timerSlides.componentsV2.openQuestion.yourAnswer')}
        maxLength={lengthLimit}
        onChange={setInputValue}
        onFocus={(): void => !shouldValidate ? setShouldValidate(true) : undefined}
        value={inputValue}
        withError={!!shouldValidate && !isLengthWithinLimits}
      />
      <StyledButton
        disabled={!isLengthWithinLimits}
        label={t('competence.app.interactions.timerSlides.componentsV2.openQuestion.accept')}
        onClick={onButtonClick}
        size={ButtonSize.Medium}
        variant={ButtonTheme.PrimaryBrand}
      />
    </Container>
  );
};
